<template>
  <div class="payment-schedule-table">
    <v-data-table
      dense
      fixed-header
      :hide-default-footer="true"
      :items-per-page="itemsData.length"
      :headers="headers"
      height="300"
      :items="itemsData"
      class="m-t-15 m-b-10"
      color="white"
    >
      <template v-slot:item.index="{ item }">
        {{item.index}}
      </template>
      <template v-slot:item.transactionMode="{ item }">
        {{ assist.tool.getEnumTextByValue(assist.dataType.TransactionModeEnum, item.transactionMode) }}
      </template>
      <template v-slot:item.transactionType="{ item }">
        {{ assist.tool.getEnumTextByValue(assist.dataType.TransactionTypeOptions, item.transactionType) }}
      </template>
      <template v-slot:item.changeType="{ item }">
        {{ assist.tool.getEnumTextByValue(assist.dataType.ChangeType, item.changeType) }}
      </template>
      <template v-slot:item.transactionAmount="{ item }">
        {{ assist.tool.fieldRender(item, '{transactionAmount}', 'currency') }}
      </template>
      <template v-slot:item.principal="{ item }">
        <span v-if="item.id">{{ assist.tool.fieldRender(item, '{principal}', 'currency') }}</span>
        <v-text-field type="number" v-if="!item.id" prefix="$" v-model="item.principal" :rules="[rules.min]" @change="principalChange(item)" hide-details style="margin-top: -8px"></v-text-field>
      </template>
      <template v-slot:item.interest="{ item }">
        {{ assist.tool.fieldRender(item, '{interest}', 'currency') }}
      </template>
      <template v-slot:item.unpaidFee="{ item }">
        {{ assist.tool.fieldRender(item, '{unpaidFee}', 'currency') }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { DataType, Tool } from '@/util/index'
import { PPS_DIALOG_LAYOUT_SETTING } from '@/setting/layout/post-origination/dialog'
const tool = new Tool()
export default {
  name: 'payment-schedule-table.vue',
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      itemsData: JSON.parse(JSON.stringify(this.items)),
      assist: {
        tool: tool,
        dataType: DataType
      },
      tableSetting: PPS_DIALOG_LAYOUT_SETTING.DRAW_CREDIT.PAYMENT_SCHEDULE_TABLE,
      rules: {
        min: function (value) {
          if (value >= 0) {
            return true
          } else if (value < 0) {
            return 'The principal field must be 0 or more'
          }
        }
      }
    }
  },
  watch: {
    itemsData (val) {
      for (let i = 0; i < val.length; i++) {
        val[i].index = i + 1
        val[i].isOperated = false
      }
    }
  },
  created () {
    this.eleIndex()
  },
  methods: {
    eleIndex () {
      for (let i = 0; i < this.itemsData.length; i++) {
        this.itemsData[i].index = i + 1
        this.itemsData[i].isOperated = false
      }
    },
    principalChange (item) {
      this.$eventBus.$emit('updateErrorMsg', '')
      item.isOperated = true
      item.transactionAmount = item.principal
      this.$eventBus.$emit('updateSaveBtnDisabled', false)
      if (item.principal < 0) {
        this.$eventBus.$emit('updateSaveBtnDisabled', true)
        this.$eventBus.$emit('updateErrorMsg', 'The principal must be 0 or more')
      }

      let totalPrinciple = 0
      let totalCount = 0
      for (const item of this.items) {
        if (!item.id) {
          totalPrinciple += Number(item.principal)
          totalCount++
        }
      }
      if (item.principal > totalPrinciple) {
        this.$eventBus.$emit('updateSaveBtnDisabled', true)
        this.$eventBus.$emit('updateErrorMsg', 'The principal must be less than total left amount!')
      }

      let operatedPrinciple = 0
      let operatedCount = 0
      for (const item of this.itemsData) {
        if (!item.id && item.isOperated) {
          operatedPrinciple += Number(item.principal)
          operatedCount++
        }
      }

      const remainingPrinciple = totalPrinciple.toFixed(2) - operatedPrinciple.toFixed(2)
      const remainingCount = totalCount - operatedCount

      let totalRemainPrinciple = 0
      for (let i = 0; i < this.itemsData.length; i++) {
        if (!this.itemsData[i].id && !this.itemsData[i].isOperated) {
          if (i === this.itemsData.length - 1) {
            this.itemsData[i].principal = Number(remainingPrinciple - totalRemainPrinciple).toFixed(2)
            this.itemsData[i].transactionAmount = Number(remainingPrinciple - totalRemainPrinciple).toFixed(2)
          } else {
            this.itemsData[i].principal = (remainingPrinciple / remainingCount).toFixed(2)
            this.itemsData[i].transactionAmount = (remainingPrinciple / remainingCount).toFixed(2)
            totalRemainPrinciple += Number(this.itemsData[i].principal)
          }
        }
      }
      this.$eventBus.$emit('refreshInstallment', this.itemsData)
      if (item.principal > totalPrinciple) {
        item.isOperated = false
      }

      let modifyPrinciple = 0
      for (const itemData of this.itemsData) {
        if (!itemData.id) {
          modifyPrinciple += Number(itemData.principal)
        }
      }
      if (modifyPrinciple !== totalPrinciple) {
        this.$eventBus.$emit('updateSaveBtnDisabled', true)
        this.$eventBus.$emit('updateErrorMsg', 'The principal must be equal to total left amount!')
      }

      if (operatedCount === totalCount) {
        for (const itemData of this.itemsData) {
          if (!itemData.id) {
            itemData.isOperated = false
          }
        }
      }
      this.$forceUpdate()
    }
  }

}
</script>

<style scoped>
  .payment-schedule-table tr td.text-start:nth-child(1){
    text-align: right !important;
  }
</style>
<style type="text/css">
  .payment-schedule-table .text-start {
    white-space: nowrap!important;
  }
</style>
